import { Typography } from "@material-ui/core";
import { Code, CodeBlock, CopyBlock, dracula } from "react-code-blocks";

export const RegraAlunoTurma = () => {

    const text = `{
    "id": string, (id da turma, pode ser consultado via API)
    "alunos": Array [
        {
            "nome": string,
            "email": string,
            "fone": string, (formato (99) 99999-9999)
        },
    ]
}`;

    const text2 = `POST /v1/inserir-aluno-turma
Host: api.app.juristta.com
Content-Type: application/json
Authorization: Bearer v1_a2f5i10a_abc123def456ghi789jk
{       
    "id": "9565dda7-d7c0-4846-8333-282449987c5b",
        "alunos": [
        {
            "nome": "João Silva",
            "email": "joao.silva@example.com",
            "fone": "(31) 99999-9999",
        },
        {
            "nome": "Maria Oliveira",
            "email": "maria.oliveira@example.com",
        }
    ]
}`;

    const text3 = `{
    "id": "9565dda7-d7c0-4846-8333-282449987c5b",
    "name": "DC I - M",
    "description": "Turma de Direito Civil I período Matutino.",
    "users": [
        {
            "id": "c40aa97c-8f88-afe7-409a-3465045e44b4",
            "name": "João Silva",
            "email": "joao.silva@example.com",
            "phone": "(31) 99999-9999"
        },
        {
            "id": "91d9683c-aadc-4a1f-bac6-0dcecbd40202",
            "nome": "Maria Oliveira",
            "email": "maria.oliveira@example.com",
            "phone": null
        }
    ]
}`;


    return <>
        <Typography variant='h6'>Inserção de alunos em turmas</Typography>
        <div style={{ marginBottom: '16px' }} />

        <Typography variant='body1'>Este endpoint permite a inserção de novos alunos em uma turma já existente. O retorno deste endpoint conterá todos os alunos da turma após a operação.</Typography>

        <div style={{ marginBlock: '16px', borderRadius: '8px', backgroundColor: '#1f1f1f', padding: '8px' }}>
            <div>
                <Typography variant="body1" component='span' style={{ fontWeight: 'bold' }}>Método:</Typography> <Typography component='span'>POST</Typography>
            </div>
            <div>
                <Typography variant="body1" component='span' style={{ fontWeight: 'bold' }}>URL:</Typography> <Typography component='span'>https://api.app.juristta.com/v1/inserir-aluno-turma </Typography>
            </div>
        </div>
        <Typography variant="h6">Parâmetros do corpo da requisição </Typography>
        <Typography variant="body1" style={{ fontFamily: 'monospace', marginBlock: '16px' }}>
            <CopyBlock codeBlockStyle={{ fontFamily: 'Arial' }} text={text} language="http" theme={dracula} codeBlock showLineNumbers />
        </Typography>
        <div style={{ marginBottom: '16px' }} />

        <Typography variant="h6">Exemplo de requisição </Typography>
        <Typography variant="body1" style={{ fontFamily: 'monospace', marginBlock: '16px' }}>
            <CopyBlock codeBlockStyle={{ fontFamily: 'Arial' }} text={text2} language="http" theme={dracula} codeBlock showLineNumbers />
        </Typography>

        <div style={{ marginBottom: '16px' }} />

        <Typography variant="h6">Exemplo de resposta </Typography>
        <Typography variant="body1" style={{ fontFamily: 'monospace', marginBlock: '16px' }}>
            <CodeBlock codeBlockStyle={{ fontFamily: 'Arial' }} text={text3} language="json" theme={dracula} />
        </Typography>
        <Typography variant="body1">Requisições que não seguirem corretamente a especificação receberão uma resposta com o status <Code language='http' text="HTTP 400 Bad Request." theme={dracula} ></Code> com detalhes do problema. </Typography>

    </>
}